import React, { useEffect } from "react";
import ForPendingServicesComponent from "../../components/ForPendingServicesPages";
import * as modalActions from "../../redux/actions/modalActions";
import * as userAuthActions from "../../redux/actions/userAuthAction";
import * as serviceActions from "../../redux/actions/serviceAction";
import * as commonActions from "../../redux/actions/commonAction";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../components/Sidebar";
import { setLanguage } from "redux-i18n";
import PropTypes from "prop-types";

const Dashboard = (props, context) => {
  const profileReducer = useSelector((state) => state.profileReducer);
  const commonReducer = useSelector((state) => state.commonReducer);

  const dispatch = useDispatch();

  const modalAction = bindActionCreators(modalActions, dispatch);

  const commonAction = bindActionCreators(commonActions, dispatch);


  const openSetModal = (children) => {
    modalAction.openSetModal(children);
  };

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  const onMenuToggle = (isOpen) => {
    commonAction.setIsSideMenuOpen(isOpen);
  };

  const languageChange = (language) => {
    dispatch(setLanguage(language));
  };

  
  
  return (
    <>
      {window.location.hash !== "#/" && (
        <Sidebar
          languageChange={languageChange}
          openSetModalAction={openSetModal}
          closeRemoveModal={closeRemoveModal}
          managersDetails={profileReducer.managersDetails}
          onMenuToggle={onMenuToggle}
          isSideMenuOpen={commonReducer.isSideMenuOpen}
          context={context}
        />
      )}

      <div className="Content-Panel">
        <ForPendingServicesComponent context={context} />
      </div>
    </>
  );
};

Dashboard.contextTypes = {
  t: PropTypes.func.isRequired,
};
export default Dashboard;
